import type { LicensingStatus } from '@core/models/organization';
import dayjs from 'dayjs';

export function getLicensingEntitlements(
  licensing: LicensingStatus | undefined,
  appId: string,
  now = dayjs()
): Map<string, string> {
  const currentApp = licensing?.apps
    .filter(
      (app) =>
        app.id === appId &&
        now.valueOf() >= dayjs(app.contract.start).valueOf() &&
        now.valueOf() <= dayjs(app.contract.end).valueOf()
    )
    .reduce<LicensingStatus['apps'][number] | undefined>(
      (latest, app) =>
        !latest || dayjs(app.contract.end).isAfter(latest.contract.end) ? app : latest,
      undefined
    );

  return new Map(
    (currentApp?.plan?.entitlements ?? [])
      .filter((entitlement) => !entitlement.deleted)
      .map(({ key, name }) => [key, name])
  );
}
